import accounting from '@src/accounting/menu';
import acl from '@src/acl/menu';
import categories from '@src/categories/menu';
import clientSettings from '@src/client-settings/menu';
import cms from '@src/cms/menu';
import customer from '@src/customer/menu';
import employeeDiscount from '@src/employee-discount/menu';
import incomingGoods from '@src/incoming-goods/menu';
import intrastat from '@src/intrastat/menu';
import manufacturer from '@src/manufacturer/menu';
import payment from '@src/payment/menu';
import pick from '@src/pick/menu';
import pos from '@src/pos/menu';
import priceSet from '@src/price-product/menu';
import printer from '@src/printer/menu';
import procurement from '@src/procurement/menu';
import productData from '@src/product-data/menu';
import productFeed from '@src/product-feed/menu';
import stocktaking from '@src/stocktaking/menu';
import url from '@src/short-url/menu';
import user from '@src/user/menu';
import userToken from '@src/user-token/menu';
import warehouse from '@src/warehouse/menu';
import workshop from '@src/workshop/menu';
import shipOut from '@src/ship-out/menu';
import supplier from '@src/supplier/menu.js';
import { MenuEntry } from '@src/menu-entry';
import mailSettings from '@src/mail-settings/menu.js';
import rdeCategories from '@src/rde-category/menu.js';
import reCall from '@src/recall/menu.js';
import development from '@src/development/menu.js';
import revocation from '@src/revocation/menu.js';
import claim from '@src/claim/menu';
import newsletter from '@src/newsletter/menu';
import cashDesk from '@src/cash-desk/menu';
import outgoingPayment from '@src/outgoing-payment/menu';
import bankStatement from '@src/bank-statement/menu';
import manualBooking from '@src/manual-booking/menu';
import journal from '@src/journal/menu';
import currentProducts from '@src/user-product/menu';
import jobrad from '@src/jobrad/menu';
import returnRequest from '@src/return-request/menu';

const menuEntries = [
    cashDesk,

    MenuEntry.create()
        .setTitle('Kunden')
        .setChildren(customer),
    MenuEntry.create()
        .setTitle('Laden')
        .setChildren(pos),
    workshop,

    MenuEntry.create()
        .setTitle('Lager')
        .setChildren([
            ...warehouse,
            MenuEntry.create()
                .setTitle('Inventur')
                .setChildren(stocktaking),
            returnRequest,
        ]),
    MenuEntry.create()
        .setTitle('Wareneingang')
        .setChildren(incomingGoods),
    MenuEntry.create()
        .setTitle('Produkte')
        .setChildren([
            ...currentProducts,
            ...jobrad,
        ]),
    pick,
    shipOut,
    MenuEntry.create()
        .setTitle('Rekla & Widerrufe')
        .setChildren([
            MenuEntry.create()
                .setTitle('Retourenempfang')
                .setRoute('return_goods_expected_returns_receive'),
            MenuEntry.create()
                .setTitle('Retourenannahme')
                .setRoute('return_goods_entry'),
            MenuEntry.create()
                .setTitle('Rücksendungen anmelden')
                .setRoute('return_goods_expected_returns_missing_label'),
            revocation,
            claim,
            reCall,
        ]),

    MenuEntry.create()
        .setTitle('Marketing')
        .setChildren([
            cms,
            rdeCategories,
            MenuEntry.create()
                .setRoute('coupon_list')
                .setTitle('Coupons')
                .setAdditionalRoutes([
                    'coupon_edit',
                    'coupon_create',
                    'coupon_show_newsletter',
                ]),
            MenuEntry.create()
                .setTitle('Url')
                .setChildren(url),
            productFeed,
            newsletter,
            mailSettings,
        ]),

    MenuEntry.create()
        .setTitle('Preise')
        .setChildren(priceSet),

    MenuEntry.create()
        .setTitle('Einkauf')
        .setChildren([
            ...procurement,
            ...supplier,
            MenuEntry.create()
                .setTitle('Unterschrittene Meldebestände')
                .setRoute('reorder_point_below_list'),
        ]),

    MenuEntry.create()
        .setTitle('Buchhaltung')
        .setChildren([
            ...accounting,
            intrastat,
            manualBooking,
            MenuEntry.create()
                .setTitle('Geldwerter Vorteil')
                .setChildren(employeeDiscount),
            ...journal,
        ]),

    MenuEntry.create()
        .setTitle('Zahlungen')
        .setChildren([
            bankStatement,
            MenuEntry.create()
                .setTitle('Gutscheine')
                .setChildren([
                    MenuEntry.create()
                        .setRoute('voucher_list')
                        .setAdditionalRoutes([
                            'voucher_edit',
                            'voucher_create',
                        ]),
                ]),
            payment,
            outgoingPayment,
            MenuEntry.create()
                .setTitle('Zuordnungsregeln')
                .setChildren([
                    MenuEntry.create()
                        .setRoute('paypal_transaction_rule_overview')
                        .setAdditionalRoutes([
                            'paypal_transaction_rules_create',
                            'paypal_transaction_rules_edit',
                        ]),
                    MenuEntry.create()
                        .setRoute('fin_api_custom_matching_list'),
                ]),
            MenuEntry.create()
                .setTitle('Einstellungen')
                .setChildren([
                    MenuEntry.create()
                        .setRoute('outgoing_payment_settings_automatic_refund'),
                    MenuEntry.create()
                        .setRoute('outgoing_payment_settings_refund_order'),
                    MenuEntry.create()
                        .setRoute('outgoing_payment_settings_waiting_for_charge_automation'),
                    MenuEntry.create()
                        .setRoute('fin_api_config'),
                ]),
        ]),

    MenuEntry.create()
        .setTitle('PIM')
        .setChildren(productData),

    MenuEntry.create()
        .setTitle('Webshop Stammdaten')
        .setChildren([
            ...categories,
            manufacturer,
        ]),

    MenuEntry.create()
        .setTitle('Einstellungen')
        .setChildren([
            MenuEntry.create()
                .setTitle('Benutzer')
                .setChildren(user),
            acl,
            clientSettings,
            printer,
            userToken,
        ]),

    development,
    MenuEntry.create()
        .setRoute('database_query_list'),
];

const menu = MenuEntry.create()
    .setRoute('home')
    .setChildren(menuEntries);

export { menu };
